export class Relatie {

  BedrijfNummer: number;
  BedrijfsNaam: string;
  Afkorting: string;
  Straat: string;
  HuisNummer: string;
  Postcode: string;
  Plaats: string;
  LandID: number;
  CorrPostbus: string;
  CorrPostcode: string;
  CorrPlaats: string;
  Telefoon: string;
  Fax: string;
  Email: string;
  URL: string;
  BTWnr: string;
  BranchID: number;
  Toelichting: string;
  KvKNummer: string;
  BankNummer: string;
  IsActief: number;
  InvoerDatum: string;
  MutatieDatum: string;
}


export class AfleverAdres {
  ID:number;
	BedrijfNummer:number;
	AdresRegel1 : string;
	AdresRegel2: string;
	AdresRegel3: string;
	AdresRegel4: string;
	IsDefault: boolean;
	Invoerdatum : string;
	MutatieDatum : string;
}


export class FactuurAdres {
  ID:number;
	BedrijfNummer:number;
	FactuurAdres:string;
	DebiteurNummer : string;
	Opmerking: string;
	BTWNr: string;
}


export class ActiveRelatie {
  BedrijfNummer : number;
  BedrijfsNaam : string;
  Afkorting : string
}


export class ActiveContactPersoon {
  ID : number;
  Achternaam : string;
  Roepnaam : string;
  TussenVoegsels : string;
}


export class ContactPersoon {
     ID : number
    ;Achternaam : string
    ;Roepnaam : string
    ;TussenVoegsels : string
    ;Initialen : string
    ;TitulatuurID : number
    ;Aanhef : string
    ;Tav : string
    ;Geslacht : string
    ;GeboorteDatum : string
    ;Straat : string
    ;HuisNummer : string
    ;Postcode : string
    ;Plaats : string
    ;Afdeling : string
    ;Functie : string
    ;InterneTel : string
    ;InterneFax : string
    ;TelPrive : string
    ;FaxPrive : string
    ;EmailDirect : string
    ;GSM : string
    ;Email : string
    ;Info1 : string
    ;Info2 : string
    ;Info3 : string
    ;PriveLandID: number
    ;IsActief: number
    ;InvoerDatum : string
    ;MutatieDatum   : string
}

export class Titulatuur {
     ID: number
    ;Titel : string
    ;Omschrijving : string
    ;InvoerDatum : string
}

export class Land {
  id: number
 ;naam : string
}
export class ObjectRelatieGegevens {
  BedrijfNummer: number;
  BedrijfsNaam: string;
  Afkorting: string;
  contactpersoonid : number;
  Achternaam:string;
}
